import { render } from "./HeartIcon.vue?vue&type=template&id=1e45b913&scoped=true"
import script from "./HeartIcon.vue?vue&type=script&lang=js"
export * from "./HeartIcon.vue?vue&type=script&lang=js"

import "./HeartIcon.vue?vue&type=style&index=0&id=1e45b913&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e45b913"]])

export default __exports__